// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { Button } from "@/components/ui/button"
import { useI18n } from "@/i18n"

interface ErrorStateProps {
  message?: string
  onRetry?: () => void
  className?: string
}

/** Truthful error state with an optional retry — never a silent fallback to fake data. */
export function ErrorState({ message, onRetry, className }: ErrorStateProps) {
  const { t } = useI18n()
  return (
    <div
      role="alert"
      className={`flex flex-col items-center gap-3 rounded-bb-xl border border-destructive/30 bg-destructive/5 px-6 py-8 text-center ${className ?? ""}`}
    >
      <p className="text-sm text-ink">{message ?? t("common.errorGeneric")}</p>
      {onRetry && (
        <Button type="button" variant="outline" size="sm" className="min-h-11" onClick={onRetry}>
          {t("state.retry")}
        </Button>
      )}
    </div>
  )
}
